import { Box, Container, Grid, Stack, Typography } from '@mui/material'
import { useEffect } from 'react'
import DashboardDetails from '../components/DashboardDetails'
import { useNavigate } from 'react-router-dom'
import { text } from '../utils/text'

const Home = () => {
  const navigate = useNavigate()
  const link = "https://app.powerbi.com/view?r=eyJrIjoiNTEwMjc5MzAtYjcwNi00Njc1LWJjNTUtNjRmNDAwNjM5NjVjIiwidCI6ImQwZDljYzdlLTc3MzQtNGRjYS1hODZjLThlOTg3ZDhhOTQzYSJ9&pageName=ReportSection3422b7f9cc90a5ca7eea"
  useEffect(() => {
    if (!localStorage.getItem('email') || !localStorage.getItem('password')) 
      navigate('/iniciar-sesion')
    
  }, [navigate])


  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
      }}

    >
      <Container >
        <Stack spacing={3}>
          <div>
            <Typography variant="h4">
              Reporte de producto
            </Typography>
            <Box
              sx={{
                backgroundColor: '#FF735C',
                padding: '4px',
                textAlign: 'center',
                border: '1px solid',
                borderRadius: '5px',
                my: '5px'
              }}
            >
              <Typography
                color="white"
                variant="body2"
              >
                &nbsp;
                {text}
              </Typography>
            </Box>

          </div>
          <div>
            <Grid container xs={12} item={true}>
              <DashboardDetails link = {link} />
            </Grid>
          </div>
        </Stack>
      </Container>
    </Box>
  )
}

export default Home